import React from 'react';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { DropDown } from 'components/form/DropDown';
import { Slider } from 'components/Slider/Slider';
import { TextBox } from 'components/form/TextBox/TextBox';
import { commafy } from 'helpers/number';
import FilterModal from 'components/FilterModal';
import FilterAndSortButton from 'components/FilterAndSortButton';
import { formatCurrency } from 'helpers/money.helper';
import LoanEstimatesDisclaimer from 'components/Disclaimer/LoanEstimateDisclaimer';
import { AUTO_PURCHASE } from 'types/morph.pagePosition.constants';
import ZeroState from 'components/ZeroState/ZeroState';

const FilterModalContent = ({ ...props }) => {
  return (
    <>
      <Row fullWidth>
        <Label className="Subtitle-1 margB8">Sort by</Label>
        <DropDown
          id="sort-by"
          list={props.sortList}
          value={props.currentSortType}
          onChange={e => props.setCurrentSortType(e)}
          label="Sort by"
          defaultValue={props.sortList[0]}
          placeholder="Sort by"
          fullWidth
        />
      </Row>
      <Row fullWidth>
        <Label className="Subtitle-1 margT24" for="slider">
          Vehicle Price
        </Label>

        <div className="fontGray400 text-center text-28 padB4">
          ${commafy(props.newAutoLoanAmount)}
        </div>
        <Slider
          min={props.MIN_NEW_AUTOLOAN}
          max={props.MAX_NEW_AUTOLOAN}
          step={500}
          value={props.newAutoLoanAmount}
          size="big"
          onChange={props.setNewAutoLoanAmount}
          fullWidth
        />
      </Row>
      <Row fullWidth>
        <Label className="Subtitle-1 margT24 margB8">Down Payment</Label>
        <TextBox
          value={
            props.newAutoLoanDownPayment.includes('$')
              ? props.newAutoLoanDownPayment
              : formatCurrency(props.newAutoLoanDownPayment)
          }
          onChange={e => props.onNewAutoLoanDownPaymentUpdate(e)}
          placeholder={'Down Payment'}
          fullWidth
        />
      </Row>
    </>
  );
};

const PersonalLoanOffersView = ({ ...props }) => {
  if (props.autoLoanOffersLoading) {
    return <PageLoadingMask />;
  }

  if (props.autoLoanOffers?.length > 0) {
    return (
      <>
        <Row>
          <FlexContainer className="flex-column">
            <StaticOfferContainer
              offerMetadataList={props.autoLoanOffers}
              termsPostfix={' mo.'}
              eventHandler={props.eventHandler}
              pagePosition={AUTO_PURCHASE}
              modulePosition={props.modulePosition}
              {...props}
            />
          </FlexContainer>
          <FlexContainer className="justify-end">
            <LoanEstimatesDisclaimer
              {...props}
              handleShowLoanEstimatesDisclaimer={
                props.handleShowLoanEstimatesDisclaimer
              }
            />
          </FlexContainer>
        </Row>
      </>
    );
  } else {
    return <ZeroState />;
  }
};

const AutoLoanMarketplaceModuleView = ({ ...props }) => {
  return (
    <>
      {props.seenModuleTracking}
      {!props.hideDisclaimer && (
        <Row fullWidth>
          <Disclaimer showPartnerText className="margB8" />
        </Row>
      )}
      <SectionContainer className="sectionContainer">
        <Row className="margB24">
          <Label typeHeader={'h3'} className="H5 text-24 m-text-20">
            Your top options from our partners based on your credit profile
          </Label>
        </Row>
        <Row className="margB8">
          <FilterAndSortButton {...props} />
        </Row>
        <PersonalLoanOffersView {...props} />
      </SectionContainer>

      <FilterModal
        showModal={props.showModal}
        onCancelFilter={props.hideModal}
        onApplyFilter={props.onApplyFilter}
        onResetFilter={props.onResetFilter}
        isApplyFilterDisabled={props.isApplyFilterDisabled}
        showResetButton={true}
      >
        <FilterModalContent {...props} />
      </FilterModal>
    </>
  );
};

export default AutoLoanMarketplaceModuleView;
